var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c("h1", { staticClass: "text-xs-center py-5" }, [
        _c("img", {
          staticStyle: { "margin-bottom": "-12px" },
          attrs: { src: "/static/images/logo.svg", width: "400px" },
        }),
      ]),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _vm.message
            ? _c(
                "v-alert",
                {
                  staticClass: "text-xs-center",
                  model: {
                    value: _vm.error,
                    callback: function ($$v) {
                      _vm.error = $$v
                    },
                    expression: "error",
                  },
                },
                [_vm._v(_vm._s(_vm.message))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authenticating
            ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-form",
            {
              staticClass: "mx-auto",
              staticStyle: { "max-width": "600px" },
              attrs: { box: "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.attemptLogin.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "v-flex",
                [
                  _c("v-text-field", {
                    ref: "username",
                    attrs: {
                      label: "Username",
                      box: "",
                      autofocus: "",
                      disabled: _vm.needTwoFactor,
                    },
                    model: {
                      value: _vm.username,
                      callback: function ($$v) {
                        _vm.username = $$v
                      },
                      expression: "username",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Password",
                      box: "",
                      type: "password",
                      disabled: _vm.needTwoFactor,
                    },
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              [
                _vm.needTwoFactor
                  ? _c(
                      "v-flex",
                      [
                        _c("v-text-field", {
                          staticClass: "py-2",
                          attrs: {
                            label: "Security Code",
                            box: "",
                            "error-messages": [_vm.twoFactorMessage],
                          },
                          model: {
                            value: _vm.code,
                            callback: function ($$v) {
                              _vm.code = $$v
                            },
                            expression: "code",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              _vm._v(" "),
              _c(
                "v-flex",
                [
                  _vm.needTwoFactor
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.sendingTwoFactor,
                            color: "warning",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.requestAuthenticationCode.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [_vm._v("\n          Resend Security Code\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        type: "submit",
                        disabled: _vm.authenticating,
                        color: "primary",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Login")))]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-xs-right" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary" },
                  on: { click: _vm.office365Login },
                },
                [_vm._v("\n        \n        Hatfield Staff Login\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }